import client from './client';

/**
 * Fetch current config (masked)
 */
export async function fetchConfig() {
  const response = await client.get('/api/admin/config');
  return response.data;
}

/**
 * Update API configuration
 */
export async function updateConfig(data) {
  const response = await client.put('/api/admin/config', data);
  return response.data;
}

/**
 * Test service connection
 */
export async function testService(service) {
  const response = await client.post(`/api/admin/test/${service}`);
  return response.data;
}
